import Box from '@mui/material/Box';
import React from 'react';
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export const HomeWelcomeMessageCard = ({ screenId }) => {
  const { controlSettings } = useWebContext(screenId);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md")); 

  return (
    <OutlinedCustomCard
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <Box sx={{ position: "relative", height: "100%", minHeight: 0 }}>

        <MyMImage
          screenId={screenId}
          filePath={controlSettings.ImageList.imgWelcomeMessage}
          alt=""
          
          width={isMobile ? "100%" : "auto"}
          height="100%"
          sx={{
            objectFit: isMobile ? "cover" : "contain",
            display: "block",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(13,13,13,0.55)",
            color: "white",
            padding: "10px",
            display: "flex",
            alignItems: "center",
            minHeight: 0,
          }}
        >
          <MyMLabel fontSize='25px' >{controlSettings.LabelList.lblWelcomeMessage}</MyMLabel>
        </Box>
      </Box>
    </OutlinedCustomCard>
  );
};